import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Icon } from 'assets/icons';
import { Button } from 'app/shared/button';
import styles from './notice.module.css';
import { useDispatch } from 'react-redux';
import { logout } from 'store/actions/user-data';

export const OrgnisationDeactivationNotice = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  return (
    <div className={styles.overlay}>
      <div className={styles.card}>
        <div className={styles.content}>
          <span className={styles.iconWrapper}>
            <Icon name="warning" width={16} height={16} />
          </span>
          <div className={styles.text}>
            <h5 className={styles.title}>Your Account Has Been Deactivated</h5>
            <p className={styles.body}>
              Because your account was inactive for more than 6 months, it has been deactivated and
              all associated data and resources have been permanently deleted, in line with our
              inactivity policy.
            </p>
            <p className={styles.body}>
              To get back on the platform, you&apos;ll need to create a new organisation. Your
              previous data cannot be restored.
            </p>
            <p className={styles.support}>
              If you believe this is an error, contact us at{' '}
              <a href="mailto:support@go-mailer.com" className={styles.supportLink}>
                support@go-mailer.com
              </a>
            </p>
          </div>
        </div>
        <div className={styles.actions}>
          <Button text="Logout" className={styles.logoutBtn} onClick={() => dispatch(logout({}))} />
          <Button text="Create New Organisation" onClick={() => navigate('/organizations')} />
        </div>
      </div>
    </div>
  );
};
